export const LANGUAGE = {
  DE: 'de',
  FR: 'fr',
  IT: 'it',
  EN: 'en',
} as const;

export const LOGIN_STATE = {
  LOGGED_OUT_WITH_BUTTON: 'logged_out_with_button',
  LOGGED_OUT_WITH_AVATAR: 'logged_out_with_avatar',
  LOGGED_IN_WITH_AVATAR: 'logged_in_with_avatar',
  LOGGED_IN_WITH_INITIALS: 'logged_in_with_initials',
} as const;

export const LOGIN_SIZES = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
} as const;

export const LOGIN_TYPE = {
  NEUTRAL: 'neutral',
  BOLD: 'bold',
} as const;
